export interface PhotoRoomReassignInitiatedProps {
  estimate_id: string;
  photo_count: number;
  photo_sources: string[];
  target_room_id: string;
  from_unmatched: boolean;
}

export interface PhotoRoomReassignedProps {
  estimate_id: string;
  photo_count: number;
  photo_sources: string[];
  target_room_id: string;
  from_unmatched: boolean;
}

export interface PhotoRoomReassignFailedProps {
  estimate_id: string;
  photo_count: number;
  photo_sources: string[];
  target_room_id: string;
  from_unmatched: boolean;
}

export interface PhotoLabelsApplyProps {
  estimate_id: string;
  photo_count: number;
  label_count: number;
  /** Legacy estimate-file photos in the selection, which cannot carry a label. */
  skipped_legacy_count: number;
}

export interface PhotoLabelsRemovedProps {
  estimate_id: string;
  photo_count: number;
  label_count: number;
}

export interface PhotoDeleteProps {
  estimate_id: string;
  photo_count: number;
  /** Selected photos held back because a single request is capped. */
  over_limit_count: number;
}

export const PHOTO_EVENTS = {
  ROOM_REASSIGN_INITIATED: "photo_room_reassign_initiated",
  ROOM_REASSIGNED: "photo_room_reassigned",
  ROOM_REASSIGN_FAILED: "photo_room_reassign_failed",
  LABELS_APPLY_INITIATED: "photo_labels_apply_initiated",
  LABELS_APPLIED: "photo_labels_applied",
  LABELS_APPLY_FAILED: "photo_labels_apply_failed",
  LABELS_REMOVED: "photo_labels_removed",
  DELETE_INITIATED: "photo_delete_initiated",
  DELETED: "photo_deleted",
  DELETE_FAILED: "photo_delete_failed",
} as const;

export interface PhotoEventPropertiesMap {
  [PHOTO_EVENTS.ROOM_REASSIGN_INITIATED]: PhotoRoomReassignInitiatedProps;
  [PHOTO_EVENTS.ROOM_REASSIGNED]: PhotoRoomReassignedProps;
  [PHOTO_EVENTS.ROOM_REASSIGN_FAILED]: PhotoRoomReassignFailedProps;
  [PHOTO_EVENTS.LABELS_APPLY_INITIATED]: PhotoLabelsApplyProps;
  [PHOTO_EVENTS.LABELS_APPLIED]: PhotoLabelsApplyProps;
  [PHOTO_EVENTS.LABELS_APPLY_FAILED]: PhotoLabelsApplyProps;
  [PHOTO_EVENTS.LABELS_REMOVED]: PhotoLabelsRemovedProps;
  [PHOTO_EVENTS.DELETE_INITIATED]: PhotoDeleteProps;
  [PHOTO_EVENTS.DELETED]: PhotoDeleteProps;
  [PHOTO_EVENTS.DELETE_FAILED]: PhotoDeleteProps;
}
